import { HStack } from '@wegroup/design-system';
import { useParams } from 'react-router';
import AnvaBasketFinishButton from '@flows/src/components/flow-products/quotes/basket/actions/AnvaBasketFinishButton';
import useQueryParams from '@common/src/hooks/useQueryParams';
import { useFlowInfo } from '@flows/src/api/getFlowInfo';
import YellowhiveBasketFinishButton from '@flows/src/components/flow-products/quotes/basket/actions/YellowHiveBasketFinishButton';

const BottomBarBasketActions = () => {
  const queryParams = useQueryParams();
  const { flowId } = useParams<{ flowId: string }>();
  const sessionId = queryParams.get('session_id') || '';

  const { data: flowInfo } = useFlowInfo(flowId || '');
  const isYellowHiveFlow = flowInfo?.sub_type === 'YELLOWHIVE';

  return (
    <HStack spacing="4" flex="1" justify="flex-end">
      {isYellowHiveFlow ? (
        <YellowhiveBasketFinishButton sessionId={sessionId} />
      ) : (
        <AnvaBasketFinishButton sessionId={sessionId} />
      )}
    </HStack>
  );
};

export default BottomBarBasketActions;
